var _rect, _rect2, _rect3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 36,
    height: 35,
    rx: 3.5,
    fill: "#FCFCFC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 36,
    height: 35,
    rx: 3.5,
    stroke: "#737AE6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 36,
    height: 35,
    rx: 3.5,
    stroke: "black",
    strokeOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2025_127879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5357 14.7852H21.3214C20.9664 14.7852 20.6786 15.073 20.6786 15.428C20.6786 15.7831 20.9664 16.0709 21.3214 16.0709H24.5357C24.8907 16.0709 25.1786 16.3587 25.1786 16.7138V25.0709C25.1786 25.426 24.8907 25.7138 24.5357 25.7138H11.6786C11.3235 25.7138 11.0357 25.426 11.0357 25.0709V16.7137C11.0357 16.3587 11.3235 16.0709 11.6786 16.0709H14.8928C15.2479 16.0709 15.5357 15.783 15.5357 15.428C15.5357 15.0729 15.2479 14.7852 14.8928 14.7852H11.6786C10.6134 14.7852 9.75 15.6486 9.75 16.7137V25.0709C9.75 26.136 10.6134 26.9994 11.6786 26.9994H24.5357C25.6008 26.9994 26.4643 26.136 26.4643 25.0709V16.7137C26.4643 15.6486 25.6008 14.7852 24.5357 14.7852Z",
    fill: "#737AE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5357 14.7852H21.3214C20.9664 14.7852 20.6786 15.073 20.6786 15.428C20.6786 15.7831 20.9664 16.0709 21.3214 16.0709H24.5357C24.8907 16.0709 25.1786 16.3587 25.1786 16.7138V25.0709C25.1786 25.426 24.8907 25.7138 24.5357 25.7138H11.6786C11.3235 25.7138 11.0357 25.426 11.0357 25.0709V16.7137C11.0357 16.3587 11.3235 16.0709 11.6786 16.0709H14.8928C15.2479 16.0709 15.5357 15.783 15.5357 15.428C15.5357 15.0729 15.2479 14.7852 14.8928 14.7852H11.6786C10.6134 14.7852 9.75 15.6486 9.75 16.7137V25.0709C9.75 26.136 10.6134 26.9994 11.6786 26.9994H24.5357C25.6008 26.9994 26.4643 26.136 26.4643 25.0709V16.7137C26.4643 15.6486 25.6008 14.7852 24.5357 14.7852Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7616 18.1884C21.5124 17.9478 21.1175 17.9478 20.8684 18.1884L18.7502 20.3053V9.64287C18.7502 9.28782 18.4624 9 18.1073 9C17.7523 9 17.4644 9.28782 17.4644 9.64287V20.3053L15.3475 18.1884C15.0921 17.9417 14.6852 17.9488 14.4385 18.2041C14.1979 18.4533 14.1979 18.8483 14.4385 19.0973L17.6528 22.3116C17.9035 22.563 18.3106 22.5635 18.5619 22.3127C18.5623 22.3124 18.5627 22.312 18.5631 22.3116L21.7774 19.0973C22.024 18.842 22.017 18.435 21.7616 18.1884Z",
    fill: "#737AE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7616 18.1884C21.5124 17.9478 21.1175 17.9478 20.8684 18.1884L18.7502 20.3053V9.64287C18.7502 9.28782 18.4624 9 18.1073 9C17.7523 9 17.4644 9.28782 17.4644 9.64287V20.3053L15.3475 18.1884C15.0921 17.9417 14.6852 17.9488 14.4385 18.2041C14.1979 18.4533 14.1979 18.8483 14.4385 19.0973L17.6528 22.3116C17.9035 22.563 18.3106 22.5635 18.5619 22.3127C18.5623 22.3124 18.5627 22.312 18.5631 22.3116L21.7774 19.0973C22.024 18.842 22.017 18.435 21.7616 18.1884Z",
    fill: "black",
    fillOpacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.835f710a.svg";
export { ForwardRef as ReactComponent };